import React from 'react';
import { Link } from 'react-router-dom';
import SignIn from '../../components/authentication/SignIn';

export default function SignInPage() {

  return (
    <>
      {/* Page Container */}
      <div id="page-container" className="mx-auto flex min-h-dvh w-full min-w-[320px] flex-col bg-gray-100 dark:bg-gray-900 dark:text-gray-100">
        
        {/* Page Content */}
        <main id="page-content" className="flex max-w-full flex-auto flex-col">
          
          <div className="mx-auto flex min-h-dvh w-full max-w-10xl items-center justify-center bg-gray-200/50 p-4 lg:p-8 dark:bg-transparent">
            
            {/* Sign In Section */}
            <div className="w-full max-w-5xl lg:py-16">
              {/* Sign In Box */}
              <div className="flex flex-col overflow-hidden rounded-lg bg-white shadow-sm md:flex-row dark:bg-gray-800 dark:text-gray-100">
                {/* Sign In Form */}
                <section className="px-6 py-10 md:w-1/2 md:px-10 lg:p-16">
                  <header className="mb-8 text-center sm:mt-0 md:text-left">
                    <h1 className="mb-1 text-2xl font-bold">Ai4Curb</h1>
                    <h2 className="text-sm font-medium text-gray-500 dark:text-gray-400">
                      Welcome, please sign in to your dashboard!
                    </h2>
                  </header>

                  {/** Sign in component */}
                  <SignIn />

                  <div className="mt-10 text-sm text-gray-500 dark:text-gray-400">
                    Don’t have an account yet?{' '}
                    <Link to="/signup" className="font-medium text-primary-600 hover:text-primary-400 dark:text-primary-400 dark:hover:text-primary-300">
                      Sign up
                    </Link>
                  </div>
                  
                </section>
                {/* END Sign In Form */}

                {/** Display image on the right side of the sign-in page */}
                <div
                  className="relative flex items-center bg-cover px-6 py-10 md:w-1/2 md:px-10 lg:p-16"
                  style={{
                    backgroundImage:
                      'url("https://cdn.tailkit.com/media/placeholders/photo-m_7p45JfXQo-600x600.jpg")',
                  }}
                >
                  <div className="absolute inset-0 bg-primary-900 bg-opacity-50" />
                  <div className="relative text-center sm:text-left">
                    {/* <p className="mb-2 font-semibold leading-relaxed text-white">
                      Sign-in to .....
                    </p>
                    <p className="text-sm font-medium text-white/75">
                      .......
                    </p> */}
                  </div>
                </div>
                {/* END Sign In Extra */}
                
              </div>

            </div> {/* END Sign In Section */}
            
          </div>
        </main>

        {/* END Page Content */}
        
      </div>
    </>
  );
}
